import React from 'react';
import './Footer.css';
import './assets/daab.jpg';
import VFed from './assets/vfed.jpg';



const Footer = () => (
  <div className="Footer">
    <div className="FooterWrapper">
      <div className='ContactData'>
        <div className='Contact'>Kontakt</div>
        <div>Katja Bär-Hanuja</div>
        <div>Derlerstraße 184</div>
        <div>66346 Püttlingen</div>
        <div>Tel: 06898/63374</div>
        <div>Email: <br></br>k.baer-hanuja@gmx.de</div>
      </div>
      



     
      
     

      <div className="VfedContainer"> <a  href="https://www.vfed.de/de/">
        <img  className="Vfed"src={VFed} alt="Test"></img>
      </a></div>
     

     

    </div>
  </div>

);

export default Footer;